import { render, staticRenderFns } from "./RelatedAgendaItems.vue?vue&type=template&id=6f0f5cd4&scoped=true"
import script from "./RelatedAgendaItems.vue?vue&type=script&lang=js"
export * from "./RelatedAgendaItems.vue?vue&type=script&lang=js"
import style0 from "./RelatedAgendaItems.vue?vue&type=style&index=0&id=6f0f5cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0f5cd4",
  null
  
)

export default component.exports